import {IntegrationMessage} from "platform/integration/message/IntegrationMessage";
import {IntegrationClassId} from "platform/integration/message/IntegrationClassId";

export class IntegrationNavigateBack implements IntegrationMessage {

    public classId: number = IntegrationClassId.NAVIGATE_BACK;

}
